import Banner from "../../components/banner/banner";
import './home.scss'
import airlineConfig from '../../config/airlineConfig';

export function Home(){
    const partners = airlineConfig.partners || [];

    return (<>
        <Banner/>
        <div className={"logos-container"}>
            {partners.map((partner, index) => (
                <a
                    key={index}
                    href={partner.url || "#"}
                    target={partner.url && partner.url !== "#" ? "_blank" : undefined}
                    rel={partner.url && partner.url !== "#" ? "noopener noreferrer" : undefined}
                    className={"logo"}
                    title={partner.name}
                >
                    <img src={partner.logo} alt={partner.name}/>
                </a>
            ))}
        </div>
    </>)
}